module.exports = __webpack_public_path__ + "img/about-zhongguo.6802d1db.png";